import defaults from './defaults.js';

/**
 * Deep-merge user spec with defaults.
 * User values take precedence. Only merges plain objects one level deep
 * for known keys (scales, labels, theme); everything else is overwritten.
 *
 * @param {Array}  data - user-supplied data array (already validated)
 * @param {Object} spec - user-supplied spec (already validated)
 * @returns {Object} merged spec
 */
export default function mergeSpec(data, spec) {
    const labelModes = defaults.annotations.labels;
    const userLabels = spec.annotations?.labels || {};

    return {
        data,
        mapping: { ...spec.mapping },
        interactive: spec.interactive ?? defaults.interactive,
        orientation: spec.orientation ?? defaults.orientation,
        position:
            spec.position === 'fill'
                ? 'stack'
                : spec.position ?? defaults.position,
        stat:
            spec.position === 'fill' && spec.stat === undefined
                ? 'percent'
                : spec.stat ?? defaults.stat,
        nCategories: spec.nCategories,
        scales: {
            x: {
                ...defaults.scales.x,
                ...spec.scales?.x,
                ticks: {
                    ...defaults.scales.x.ticks,
                    ...spec.scales?.x?.ticks,
                },
            },
            y: { ...defaults.scales.y, ...spec.scales?.y },
            fill: { ...defaults.scales.fill, ...spec.scales?.fill },
        },
        labels: { ...defaults.labels, ...spec.labels },
        annotations: {
            ...defaults.annotations,
            ...spec.annotations,
            labels: {
                segment: {
                    ...labelModes.segment,
                    ...userLabels.segment,
                },
                total: {
                    ...labelModes.total,
                    ...userLabels.total,
                },
            },
        },
        theme: { ...defaults.theme, ...spec.theme },
        tooltip: { ...defaults.tooltip, ...spec.tooltip },
        zoom: { ...defaults.zoom, ...spec.zoom },
        legend: { ...defaults.legend, ...spec.legend },
        callbacks: {
            onClick: spec.callbacks?.onClick ?? defaults.callbacks.onClick,
            onHover: spec.callbacks?.onHover ?? defaults.callbacks.onHover,
            onSelect: spec.callbacks?.onSelect ?? null,
        },
        selection: { ...defaults.selection, ...spec.selection },
    };
}
